/* eslint-disable */
import customModal from "../customModal/customModal.vue";

export default {
    name: "ViewRiskInfoModal",

    components: {
        customModal,
    },

    props: {
        data: {
            type: Object,
            required: true,
        },
    },

    emits: ["closeModal"],

    methods: {
        riskLevelBadgeClass(level) {
            switch ((level || "").toLowerCase()) {
                case "high":
                    return "badge badge-warning";
                case "medium":
                    return "badge badge-info";
                case "low":
                    return "badge badge-success";
                default:
                    return "badge badge-secondary";
            }
        },
    }
};
